export default {
  // 用户信息
  userInfo: {}
}



// WEBPACK FOOTER //
// ./src/vuex/state.js